import { apiClient } from './client';
import type {
  Product,
  CreateProductRequest,
  UpdateProductRequest,
  SearchProductsQuery,
  ListProductsResponse,
  SearchOffQuery,
  SearchOffResponse,
} from '@/types/api';

export async function getProducts(params?: SearchProductsQuery): Promise<ListProductsResponse> {
  const response = await apiClient.get<ListProductsResponse>('/products', { params });
  return response.data;
}

export async function getProduct(id: number): Promise<Product> {
  const response = await apiClient.get<Product>(`/products/${id}`);
  return response.data;
}

export async function createProduct(data: CreateProductRequest): Promise<Product> {
  const response = await apiClient.post<Product>('/products', data);
  return response.data;
}

export async function updateProduct(id: number, data: UpdateProductRequest): Promise<Product> {
  const response = await apiClient.patch<Product>(`/products/${id}`, data);
  return response.data;
}

export async function deleteProduct(id: number): Promise<void> {
  await apiClient.delete(`/products/${id}`);
}

export async function searchOff(params: SearchOffQuery): Promise<SearchOffResponse> {
  const response = await apiClient.get<SearchOffResponse>('/products/search/off', { params });
  return response.data;
}
